import { useWindowSize } from "./useWindowSize.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  useWindowSize
};
//# sourceMappingURL=index.js.map
